import { render } from "./Macaron.vue?vue&type=template&id=11afcc58&scoped=true"
import script from "./Macaron.vue?vue&type=script&lang=js"
export * from "./Macaron.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11afcc58"]])

export default __exports__